export default __webpack_public_path__ + "static/media/security.ba67d2d1.svg";